import { graphql, HttpResponse } from 'msw'
import {
  type SubmitWireOutputV3,
  type BankingInstitution,
  WireStatus,
  type SubmitAcatDocumentsOutput,
  type ReviewJointAcatTransferOutput,
  type PendingJointAcatTransfersOutput,
  PendingJointAcatTransferStatus,
  JointAcatTransferType,
} from '../../../models'

export const achInstitutionNameMock: BankingInstitution = {
  __typename: 'BankingInstitution',
  bankName: 'Bank of America',
}

export const wireInstitutionNameMock: BankingInstitution = {
  __typename: 'BankingInstitution',
  bankName: 'Bank of America',
}

export const submitWireV3Mock: SubmitWireOutputV3 = {
  __typename: 'Wire',
  money: {
    amount: 10000,
    currencyCode: 'USD',
  },
  isSubmitted: true,
  reference: 'Funds to buy car',
  status: WireStatus.SUBMITTED,
  accountAlias: 0,
}

export const submitAcatDocumentsMock: SubmitAcatDocumentsOutput = {
  __typename: 'SubmitAcatDocumentsSuccess',
  isSuccessful: true,
}

export const mockGetAchInstitutionNameHandler = graphql.query('achInstitutionName', () => {
  return HttpResponse.json({ data: { achInstitutionName: achInstitutionNameMock } })
})

export const mockGetWireInstitutionNameHandler = graphql.query('wireInstitutionName', () => {
  return HttpResponse.json({ data: { wireInstitutionName: wireInstitutionNameMock } })
})

export const mockSubmitWireV3Handler = graphql.mutation('submitWireV3', () => {
  return HttpResponse.json({ data: { submitWireV3: submitWireV3Mock } })
})

export const mockSubmitAcatDocumentsHandler = graphql.mutation('submitAcatDocuments', () => {
  return HttpResponse.json({ data: { submitAcatDocuments: submitAcatDocumentsMock } })
})

export const pendingJointAcatTransfersMock: PendingJointAcatTransfersOutput = {
  pendingJointAcatTransfers: [
    {
      pendingAcatTransferAlias: 123,
      jointAccountHolderFirstName: 'John Doe',
      submittedFileNames: ['Document 1.pdf', 'Document 2.pdf', 'Document 3.pdf'],
      transferType: JointAcatTransferType.FULL,
      toAccountAlias: 16,
      status: PendingJointAcatTransferStatus.REJECTED,
    },
    {
      pendingAcatTransferAlias: 305,
      jointAccountHolderFirstName: 'Jane Doe',
      submittedFileNames: ['Doc 1.pdf', 'Doc 2.pdf'],
      transferType: JointAcatTransferType.FULL,
      toAccountAlias: 16,
      status: PendingJointAcatTransferStatus.IN_JOINT_OWNER_REVIEW,
    },
  ],
}

export const mockGetPendingJointAcatTransfersHandler = graphql.query('pendingJointAcatTransfers', () => {
  return HttpResponse.json({ data: { pendingJointAcatTransfers: pendingJointAcatTransfersMock } })
})

export const authorizeJointAcatTransferMock: ReviewJointAcatTransferOutput = {
  __typename: 'ReviewJointAcatTransferSuccess',
  isSuccessful: true,
}

export const rejectJointAcatTransferMock: ReviewJointAcatTransferOutput = {
  __typename: 'ReviewJointAcatTransferSuccess',
  isSuccessful: true,
}

export const mockAuthorizeJointAcatTransferHandler = graphql.mutation('authorizeJointAcatTransfer', () => {
  return HttpResponse.json({ data: { authorizeJointAcatTransfer: authorizeJointAcatTransferMock } })
})

export const mockRejectJointAcatTransferHandler = graphql.mutation('rejectJointAcatTransfer', () => {
  return HttpResponse.json({ data: { rejectJointAcatTransfer: rejectJointAcatTransferMock } })
})

export const mockTransfer = [
  mockGetAchInstitutionNameHandler,
  mockGetWireInstitutionNameHandler,
  mockSubmitWireV3Handler,
  mockSubmitAcatDocumentsHandler,
  mockGetPendingJointAcatTransfersHandler,
  mockAuthorizeJointAcatTransferHandler,
  mockRejectJointAcatTransferHandler,
]
